module.exports = __webpack_public_path__ + "static/media/C1-linkedIn.24870a2a.svg";